const MAX_DIGITS = 13;

export const digitsToCents = digits => {
  const cleaned = String(digits || '').replace(/\D/g, '').slice(0, MAX_DIGITS);
  if (!cleaned) return 0;
  return parseInt(cleaned, 10) || 0;
};

export const centsToDisplay = cents => {
  const safeCents = Math.max(0, Math.floor(Number(cents) || 0));
  return (safeCents / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const numberToCents = value => {
  if (value === null || value === undefined || value === '') return 0;
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  if (Number.isNaN(num) || num < 0) return 0;
  return Math.round(num * 100);
};

export const centsToNumber = cents => {
  const safeCents = Math.max(0, Math.floor(Number(cents) || 0));
  return Number((safeCents / 100).toFixed(2));
};

export const applyDigit = (cents, digit) => {
  const d = String(digit);
  if (!/^\d$/.test(d)) return Math.max(0, Math.floor(Number(cents) || 0));
  const current = Math.max(0, Math.floor(Number(cents) || 0));
  const next = current * 10 + Number(d);
  if (String(next).length > MAX_DIGITS) return current;
  return next;
};

export const backspaceCents = cents => {
  const current = Math.max(0, Math.floor(Number(cents) || 0));
  return Math.floor(current / 10);
};

export const digitsFromPaste = text =>
  String(text || '')
    .replace(/\D/g, '')
    .slice(0, MAX_DIGITS);
